import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from './images/phone.png';
import _imports_1 from './images/addtress.png';
import _imports_2 from './images/email.png';
var _hoisted_1 = {
  class: "contact-container"
};

var _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container-fluild\"><div class=\"row long-row\"><span class=\"title\">联系我们</span></div></div><div class=\"container long-container wow animate__animated animate__fadeInUp\" data-wow-duration=\"2s\"><div class=\"row\"><div class=\"col-lg-4 root\"><div class=\"inside-root\"><span class=\"icon\"><img src=\"" + _imports_0 + "\" alt=\"电话\"></span><h3>联系电话</h3><p>Tel: 15800616566</p></div></div><div class=\"col-lg-4 root\"><div class=\"inside-root\"><span class=\"icon\"><img src=\"" + _imports_1 + "\" alt=\"地址\"></span><h3>公司地址</h3><p>上海市闵行区春东路508号IF如果创意产业园A栋7层</p></div></div><div class=\"col-lg-4 root\"><div class=\"inside-root\"><span class=\"icon\"><img src=\"" + _imports_2 + "\" alt=\"邮箱\"></span><h3>公司邮箱</h3><p>Mailto: info@zuofeibio.com</p></div></div></div></div>", 2);

var _hoisted_4 = {
  class: "container-fluild form-container"
};
var _hoisted_5 = {
  class: "container form-content wow animate__animated animate__fadeInUp",
  "data-wow-duration": "2s"
};
var _hoisted_6 = {
  class: "row"
};
var _hoisted_7 = {
  class: "col-lg-6 long-input"
};

var _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "*"), /*#__PURE__*/_createTextVNode("您的姓名：")], -1);

var _hoisted_9 = {
  class: "col-lg-6 long-input"
};

var _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "*"), /*#__PURE__*/_createTextVNode("联系电话：")], -1);

var _hoisted_11 = {
  class: "row"
};
var _hoisted_12 = {
  class: "col-lg-6 long-input"
};

var _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "*"), /*#__PURE__*/_createTextVNode("您的公司：")], -1);

var _hoisted_14 = {
  class: "col-lg-6 long-input"
};

var _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "您的邮箱：", -1);

var _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "留言：", -1);

var _hoisted_17 = /*#__PURE__*/_createTextVNode("提交");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_form = _resolveComponent("el-form");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form, {
    model: $setup.UserMsg
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_form_item, {
        prop: "link_man",
        rules: [{
          required: true,
          message: '姓名/昵称不能为空'
        }]
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: $setup.UserMsg.link_man,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return $setup.UserMsg.link_man = $event;
            }),
            size: "large",
            placeholder: "请输入您的姓名/昵称"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_el_form_item, {
        prop: "link_mobile",
        rules: [{
          required: true,
          message: '联系电话不能为空'
        }]
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: $setup.UserMsg.link_mobile,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return $setup.UserMsg.link_mobile = $event;
            }),
            size: "large",
            placeholder: "请输入您的联系电话",
            maxlength: "11"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      })])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createVNode(_component_el_form_item, {
        prop: "company_name",
        rules: [{
          required: true,
          message: '公司名称不能为空'
        }]
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: $setup.UserMsg.company_name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return $setup.UserMsg.company_name = $event;
            }),
            size: "large",
            placeholder: "请输入您的公司名称"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createVNode(_component_el_form_item, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: $setup.email,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return $setup.email = $event;
            }),
            size: "large",
            placeholder: "请输入您的邮箱"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      })])]), _hoisted_16, _createVNode(_component_el_form_item, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: $setup.UserMsg.details[0].special_needs,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return $setup.UserMsg.details[0].special_needs = $event;
            }),
            type: "textarea",
            placeholder: "请输入",
            rows: "4"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        color: "#4F68AC",
        onClick: $setup.sendMsg
      }, {
        default: _withCtx(function () {
          return [_hoisted_17];
        }),
        _: 1
      }, 8, ["onClick"])];
    }),
    _: 1
  }, 8, ["model"])])])]);
}